// Altitude mode arrives as the TerrainMode token ("RELATIVE" | "AMSL" | "AGL"); the labels
// must match the ones offered in the route form so a mission reads the same way everywhere.
const ALTITUDE_MODE_LABELS: Record<string, string> = {
  RELATIVE: 'Relative to Launch',
  AMSL: 'AMSL',
  AGL: 'Above Terrain',
};

export const formatAltitudeMode = (mode?: string | null): string => {
  if (!mode) return '';

  const known = ALTITUDE_MODE_LABELS[mode.toUpperCase()];
  if (known) return known;

  return mode
    .toLowerCase()
    .split(/[_\s]+/)
    .filter(Boolean)
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');
};
